import { useEffect, useRef, useState } from 'react';

export default function ResearcherSection() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      id="researcher"
      className="py-16 md:py-24 px-4 md:px-8 bg-gradient-to-b from-amber-50 to-white"
    >
      <div className="max-w-6xl mx-auto">
        <div
          className={`transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="flex flex-col md:flex-row items-center gap-12 md:gap-20">

            {/* 왼쪽: 텍스트 */}
            <div className="flex-1 flex flex-col items-start text-left">

              {/* 이름 */}
              <h2
                className="text-5xl md:text-6xl font-extrabold text-gray-900 mb-1 leading-tight"
                style={{ fontFamily: "'SeolibcheYugeonwook', sans-serif" }}
              >
                어정희
              </h2>
              <p className="text-base md:text-lg font-semibold tracking-widest text-gray-400 mb-4 uppercase">
                EUH JUNG HEE
              </p>

              {/* 직함 */}
              <div className="flex flex-col gap-1 mb-6">
                <p className="text-sm md:text-base text-gray-700 font-medium">사람아이앤지(주) 대표</p>
                <p className="text-sm md:text-base text-gray-700 font-medium">사람아이앤지 아카데미 대표강사</p>
                <p className="text-sm md:text-base text-gray-700 font-medium">장로회신학대학원 역사신학 전공</p>
              </div>

              {/* 구분선 */}
              <div className="w-12 h-1 bg-amber-400 rounded-full mb-6"></div>

              {/* 석사논문 */}
              <div className="bg-white rounded-2xl shadow-sm p-5 md:p-6 mb-6 border border-amber-100 w-full">
                <div className="flex items-start gap-3">
                  <i className="ri-book-open-line text-xl text-amber-500 mt-0.5 flex-shrink-0"></i>
                  <div>
                    <h3 className="text-xs font-semibold text-gray-400 mb-1 tracking-wide uppercase">석사논문</h3>
                    <p className="text-base md:text-lg font-bold text-gray-900 leading-relaxed">
                      「19세기 미국여성선교사가 조선여성에게 끼친 영향」
                    </p>
                  </div>
                </div>
              </div>

              {/* 미션 */}
              <div className="bg-gradient-to-r from-amber-100 to-amber-50 rounded-2xl px-6 py-4 shadow-sm w-full">
                <p className="text-base md:text-lg font-medium text-gray-800 leading-relaxed whitespace-nowrap">
                  잊혀진 이야기를 발굴하여 오늘의 교회에 전합니다.
                </p>
                <p className="text-base md:text-lg font-medium text-gray-800 leading-relaxed mt-3">
                  라이브커머스를 통해 물건을 소개하는 일에 진심입니다.
                </p>
                <p className="text-base md:text-lg font-medium text-gray-800 leading-relaxed mt-3">
                  AI를 통해 개인 안의 창작의 힘을 불어넣는 일을 사랑합니다.
                </p>
              </div>
            </div>

            {/* 오른쪽: 사진 */}
            <div className="flex-1 flex justify-center md:justify-end">
              <div className="w-full h-[500px] md:h-[600px] rounded-3xl overflow-hidden shadow-xl border-4 border-white">
                <img
                  src="https://static.readdy.ai/image/3c653b3a8a919d24e4f7a2804547f79c/2dd78a756a3e4835c34411524b531e78.png"
                  alt="어정희 프로필"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}